import {FilledCreditCardIcon, Typography, UnstableCard as Paper} from '@yandex-delivery/blocks'
import React, {memo} from 'react'

import {Body, Header} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'

import {BusinessBannerModal} from '../BusinessBannerModal/BusinessBannerModal'
import {Business} from './Business/Business'
import {Card} from './Card/Card'
import {usePaymentMethod} from './hooks'
import {translations} from './i18n'
import * as classes from './PaymentMethod.classes'
import type {Props} from './types'

export const PaymentMethod = memo<Props>(function PaymentMethod({name}) {
  const {isBusiness, isBannerVisible, toggleBannerVisibilityHandler, toBody, bannerActiveButtonClickHandler} =
    usePaymentMethod()

  return (
    <>
      <Paper className={classes.paper} radius="L">
        <Body
          tail={
            <>
              <Card getBody={toBody} name={name} showRadio={isBusiness} />
              {isBusiness && <Business checked={isBannerVisible} onClick={toggleBannerVisibilityHandler} />}
            </>
          }
        >
          <Header className={classes.header} lead={<FilledCreditCardIcon />}>
            <Typography group="normal" thickness="medium" variant="title4">
              {i18n('ndd.payment.title', 'Оплата')}
            </Typography>
          </Header>
        </Body>
      </Paper>
      <BusinessBannerModal
        description={translations.description}
        imageSrc={translations.imageSrc}
        list={translations.list}
        onActionButtonClick={bannerActiveButtonClickHandler}
        onClose={toggleBannerVisibilityHandler}
        opened={isBannerVisible}
        title={translations.title}
        utmSource="order_offer"
      />
    </>
  )
})
